import { FC } from "react";
import gendalfIcon from "./icons/gendalf.png";
import { IPopupProps, Popup } from "../Popup";
import { AppContext } from "../../Menu/MenuButton";
import { ThinButton } from "../../Buttons/ThinButton/ThinButton";
import { Ticket, TicketType } from "../../TicketsPanel/Ticket";
import { useNavigate } from "react-router-dom";
import { AssetsContext } from "../../../pages/AssetsPage/AssetsTypes";
import styles from "./NotEnoughTickets.module.scss";
import { ActionsContext } from "../../../pages/ActionsPage/ACtionsRoutes";

interface INotEnoughTicketsProps extends IPopupProps {
    needAmount: number;
    ticketType: TicketType;
}

export const NotEnoughTickets: FC<INotEnoughTicketsProps> = ({ needAmount, ticketType, onClose }) => {
    const navigate = useNavigate();

    const toTaskHandler = () => {
        onClose && onClose();
        navigate(`/${AppContext.Actions}/${ActionsContext.Tasks}`);
    }

    const toCollectionHandler = () => {
        onClose && onClose();
        navigate(`${AppContext.Assets}/${AssetsContext.Collections}`);
    }

    const getTaskDescription = () => {   
        return (
            <>
                { getText() }
                <ThinButton caption='Перейти к заданиям' handler={ toTaskHandler } />
            </>
        );
    }

    const getCollectionsDescription = () => {   
        return (
            <>
                { getText() }
                <ThinButton caption='Перейти к коллекциям' handler={ toCollectionHandler } />
            </>
        );
    }

    const isLegendary = () => ticketType === TicketType.Legendary;

    const getText = () => {
        const valuedTicket =
            <span className={ styles.inlineTicket }>
                <Ticket type={ ticketType} value={ needAmount } precission={ 0 } postfix=" шт." context="balance-error"/>
            </span>;

        const ticket = <span className={ styles.inlineTicket }><Ticket type={ ticketType} hideValue={true} value={0} context="balance-error" /></span>;

        return <div className={ styles.descriptionText }>Для участия в розыгрыше требуется {valuedTicket}<br />
Получить {ticket} можно { isLegendary() ? `собрав эпическую коллекцию.` : ` выполняя задания`}.</div>;
    }

    const getDescription = () => isLegendary() ? getCollectionsDescription() : getTaskDescription();

    return (
        <Popup
            title="Ты не пройдешь"
            description={ getDescription() }
            icon={ gendalfIcon }
            onClose={ onClose }
        />
    );
};
